<template>
    <Multiselect
        :initial-value="initialValue"
        :options="options"
        :loading="loading"
        :placeholder="$t('campaigns')"
        searchable
        group-label="group"
        group-values="campaigns"
        track-by="id"
        label="name"
        select-label=""
        show-checkboxes
        show-selected
        multiple
        :close-on-select="false"
        :clear-on-select="false"
        class="width-200"
        group-select
        v-bind="$attrs"
        v-on="$listeners"
    />
</template>



<script>
    import differenceBy from 'lodash/differenceBy';
    import sortBy from 'lodash/sortBy';
    import Multiselect from './Multiselect.vue';

    export default {
        name: 'MultiselectAvailableCampaigns',
        components: {
            Multiselect,
        },
        data() {
            return {
                requestActiveCampaigns: this.$req('buyboxes/ActiveCampaigns'),
                requestAvailableCampaigns: this.$req('buyboxes/AvailableCampaigns'),
            };
        },
        computed: {
            loading() {
                return this.requestAvailableCampaigns.getLoading() || this.requestActiveCampaigns.getLoading();
            },
            activeCampaigns() {
                return sortBy(this.requestActiveCampaigns.getData() || [], 'name');
            },
            availableCampaigns() {
                return sortBy(this.requestAvailableCampaigns.getData() || [], 'name');
            },
            otherCampaigns() {
                return differenceBy(this.availableCampaigns, this.activeCampaigns, 'id');
            },
            options() {
                return [
                    {
                        group: this.$t('optionsActiveCampaignsLabel'),
                        campaigns: this.activeCampaigns,
                    },
                    {
                        group: this.$t('optionsOtherCampaignsLabel'),
                        campaigns: this.otherCampaigns,
                    },
                ];
            },
            initialValue() {
                return this.$attrs['initial-value'] || this.options[0]?.campaigns?.map(item => item.id);
            },
        },
        methods: {
            fetchCampaigns() {
                const id = this.$store.getters['plugin/getProducerPlugin'].id;
                this.requestAvailableCampaigns.get({ urlParams: { id, v: 1 } });
                this.requestActiveCampaigns.get({ urlParams: { id } });
            },
        },
        created() {
            this.fetchCampaigns();
        },
    };
</script>



<i18n lang="json" locale="pl" scope="local">
{
    "optionsActiveCampaignsLabel": "Wyświetlane w pluginie",
    "optionsOtherCampaignsLabel": "Pozostałe sklepy"
}
</i18n>

<i18n lang="json" locale="en" scope="local">
{
    "optionsActiveCampaignsLabel": "Displayed in plugin",
    "optionsOtherCampaignsLabel": "Other campaigns"
}
</i18n>
